import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Users, CheckCircle, Search, ShieldCheck } from 'lucide-react';
export function Steps() {
  const steps = [{
    text: 'Llámame o escríbeme hoy',
    icon: Phone
  }, {
    text: 'Cuéntame sobre tu familia y tus necesidades',
    icon: Users
  }, {
    text: 'Verificamos si calificas para inscribirte ahora mismo',
    icon: CheckCircle
  }, {
    text: 'Yo encuentro el plan perfecto para ti',
    icon: Search
  }, {
    text: 'Tu familia queda protegida — ¡hoy mismo!',
    icon: ShieldCheck
  }];
  return <section className="py-10 md:py-24 bg-cream" data-id="element-339">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-341">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-342">
            ASÍ DE FÁCIL ES EMPEZAR
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-343" />
        </motion.div>

        <div className="relative" data-id="element-344">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gold/20 -translate-y-1/2 z-0" data-id="element-345" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative z-10" data-id="element-346">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="flex flex-col items-center text-center" data-id="element-347">
                  <div className="w-16 h-16 rounded-full bg-navy text-white flex items-center justify-center mb-6 relative shadow-lg border-4 border-cream" data-id="element-348">
                    <Icon className="w-6 h-6" data-id="element-349" />
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gold rounded-full flex items-center justify-center text-xs font-bold text-navy" data-id="element-350">
                      {index + 1}
                    </div>
                  </div>
                  <p className="font-medium text-navy text-lg" data-id="element-351">{step.text}</p>
                </motion.div>;
          })}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-16 text-center" data-id="element-352">
          <p className="text-3xl font-serif font-bold text-gold italic" data-id="element-353">
            ¡Eso es todo!
          </p>
        </motion.div>
      </div>
    </section>;
}